import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateText,
	validatePhoneNumber,
} from '../../../util/validation/commonValidation';
import type { FullOperatorDto } from '../types/OperatorDto';


export function useAddStaffEmergencyForm(defaultOperator: FullOperatorDto) {
	const [inputs, setInputs] = useState<FullOperatorDto>(defaultOperator);

	const form = useForm<FullOperatorDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			emergencyContactName: (value) =>
				validateText(value, false, 'Emergency contact name'),
			emergencyContactNumber: (value) => validatePhoneNumber(value, false),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
